import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import { selectMCByLocation } from 'shared/slice/masterControlSelectByLocationSlice';
import { selectMCBySwitch } from 'shared/slice/masterControlBySwitchSelectSlice';

import styled, { css } from 'styled-components';
import {
  flexBoxCenter,
  cardPanel,
  cardButton,
} from 'shared/styles/commonStyles';

import SelectLocations from './SelectLocations';
import MobileControlLayout from 'features/masterControl/components/shared/MobileControlLayout';
import InputTempMessage from 'shared/components/userMessages/inputTempMessage';

import {
  SwitchSectionTop,
} from 'features/masterControl/components/shared/styles/switchCardStyles';
import { MessageBoxWrapper } from 'features/masterControl/components/shared/styles/controlButtons';

const WindFactor = ({
  scope,
  swtName,
  handleOnClick,
  handleClose,
  specificLocation,
  disabled,
}) => {
  const isMobile = useMediaQuery({ query: '(max-width:600px)' });
  const type = scope === 'switch' ? 'locations' : 'switches';

  const switchStatus = useSelector(
    scope === 'switch' ? selectMCBySwitch : selectMCByLocation
  );
  const { selectedOne } = switchStatus.windFactor;

  const [openMessageBox, setOpenMessageBox] = useState(false);
  const [messages, setMessages] = useState([]);

  const handleApply = () => {
    if (!selectedOne) {
      setOpenMessageBox(true);
      setMessages(['select locations', 'please select location to continue']);
      handleOnClick(
        'windFactor',
        'selectA',
        scope,
        '_',
        '_',
        type,
        specificLocation
      );
    } else {
      handleOnClick('windFactor', 'on', scope);

      if (isMobile && scope !== 'switch') {
        handleClose();
      }
    }
  };

  if (isMobile) {
    return (
      <MobileControlLayout
        scope={scope}
        swtName={swtName}
        specificLocation={specificLocation}
        controlName='windFactor'
        logoSrc='images/logo-windFactor.svg'
        label={
          <>
            wind factor<br />program
          </>
        }
        labelSmall='wind factor program'
        onApply={handleApply}
        subtitle='wind factor program'
        messages={messages}
        openMessageBox={openMessageBox}
        onCloseMessageBox={() => setOpenMessageBox(false)}
      />
    );
  }

  return (
    <Wrapper>
      <SwitchSectionTop>
        <Title>
          wind Factor program
          <img src='images/logo-windFactor.svg' alt='' />
        </Title>
        <SelectLocations
          size={2}
          name='windFactor'
          scope={scope}
          swtName={swtName}
          specificLocation={specificLocation}
        />
      </SwitchSectionTop>

      <SectionButton>
        <ButtonWrapper onClick={handleApply} disabled={disabled}>
          <ButtonInner disabled={disabled}>
            <ButtonHole disabled={disabled}>
              <ButtonTop disabled={disabled}>apply</ButtonTop>
            </ButtonHole>
          </ButtonInner>
        </ButtonWrapper>
      </SectionButton>

      {openMessageBox && (
        <MessageBoxWrapper>
          <InputTempMessage
            onClose={() => setOpenMessageBox(false)}
            title='master control'
            messages={messages}
          />
        </MessageBoxWrapper>
      )}
    </Wrapper>
  );
};

export default WindFactor;



const Wrapper = styled.div`
  ${cardPanel}
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16.8px;
  width: 100%;
  height: 169.6px;
  position: relative;
  overflow: visible;

  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 112px;
    height: 112px;
    background-image: url('images/logo-windFactor.svg');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    opacity: 0.06;
    pointer-events: none;
    z-index: 0;
  }
`;

const Title = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-family: 'Inter', sans-serif;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  color: var(--switch-text-secondary);
  text-transform: capitalize;
  position: relative;
  z-index: 1;

  img {
    width: 16px;
    height: 16px;
    filter: drop-shadow(0px 0px 16px rgba(147, 197, 253, 0.6));
  }
`;

const SectionButton = styled.section`
  width: 100%;
  ${flexBoxCenter}
  margin-top: auto;
  position: relative;
  z-index: 0;
`;

const ButtonWrapper = styled.button`
  width: 100%;
  height: 40px;
  ${cardButton}
  border-radius: 9999px;
  ${flexBoxCenter};
  cursor: pointer;

  ${(p) =>
    p.disabled &&
    css`
      opacity: 0.5;
      cursor: not-allowed;
    `}
`;

const ButtonInner = styled.div`
  ${flexBoxCenter}
  width: 100%;
  height: 100%;
`;

const ButtonHole = styled.div`
  ${flexBoxCenter}
  width: 100%;
  height: 100%;
`;

const ButtonTop = styled.div`
  ${flexBoxCenter}
  width: 100%;
  height: 100%;
  font-family: 'Inter', sans-serif;
  font-weight: 500;
  font-size: 12px;
  color: var(--switch-text-secondary);

  ${(p) =>
    p.disabled &&
    css`
      color: #808080;
    `}
`;
